import { render, staticRenderFns } from "./ChainTableHeader.vue?vue&type=template&id=78e7a048"
import script from "./ChainTableHeader.vue?vue&type=script&lang=js"
export * from "./ChainTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports